module.exports = __webpack_public_path__ + "static/media/icon_customer.017e0c6b.svg";